import { useCallback, useEffect, useState, createContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { navigation } from './navigation';
import { Box, Modal, Stack } from '@mui/material';
import Upgrade from '../../../pages/mobile/upgrade';
import Quest from '../../../pages/mobile/quest';
import Metrics from '../../../pages/mobile/metrics';

export const LayoutContext = createContext({});
export default function LayoutProvider({
  children
}) {
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const [active, setActive] = useState(navigation[0].name);
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);
  const downMd = useMediaQuery(theme => theme.breakpoints.down(1200));
  const handleCloseMobileSidebar = () => setShowMobileSideBar(false);

  const handleActiveMainMenu = menuItem => () => {
    navigate(menuItem.path);
    setActive(menuItem.name);
  };

  // const activeRoute = useCallback(() => {
  //   navigation.forEach(menu => {
  //     if (menu.path === pathname) {
  //       setActive(menu.name);
  //     }
  //   });

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // useEffect(() => {
  //   activeRoute();
  // }, [activeRoute]);

  console.log('asdf', active)

  return <LayoutContext.Provider value={{
    active,
    downMd,
    showMobileSideBar,
    handleActiveMainMenu,
    handleCloseMobileSidebar,
  }}>
    {children}
    <Modal open={active === 'Upgrade'} sx={{ zIndex: 96, pt: '50px' }}>
      <Stack sx={{ background: '#000', height: 'calc(100vh - 110px)', overflow: 'scroll' }}>
        <Box pt={1} pb={2}>
          <Upgrade />
        </Box>
      </Stack>
    </Modal>
    <Modal open={active === 'Tasks'} sx={{ zIndex: 96, pt: '50px' }}>
      <Stack sx={{ background: '#000', height: 'calc(100vh - 110px)', overflow: 'scroll' }}>
        <Box pt={1} pb={2}>
          <Quest />
        </Box>
      </Stack>
    </Modal>
    <Modal open={active === 'Metrics'} sx={{ zIndex: 96, pt: '50px' }}>
      <Stack sx={{ background: '#000', height: 'calc(100vh - 110px)', overflow: 'scroll' }}>
        <Box pt={1} pb={2}>
          <Metrics />
        </Box>
      </Stack>
    </Modal>
  </LayoutContext.Provider>;
}